import React from 'react'
import classnames from 'classnames/bind'

import { Notification } from '@caudena/core/ui-kit'
import { Typography } from '@caudena/core/ui-kit'
import Link from '@caudena/core/Link'

import { CaseMentionNotification as N } from '../../apiServices'

import styles from './index.scss'

const cx = classnames.bind(styles)

interface CaseMentionNotificationProps {
  notification: N
  closeToast?: () => void
}

export const CaseMentionNotification: React.FC<
  CaseMentionNotificationProps
> = ({ notification: { id, user }, closeToast }) => (
  <Notification.Body closeToast={closeToast} type="default">
    <Typography variant="body1" color="grey1">
      <Link to="/cases/:id" className={cx('Bold')} params={{ id }}>
        Mention:
      </Link>
      <Typography variant="body3" color="grey1">
        {' '}
        {user}{' '}
      </Typography>
      mentioned you in case record for{' '}
      <Link to="/cases/:id" params={{ id }}>
        Case #{id}
      </Link>
    </Typography>
  </Notification.Body>
)
